import phonesReducer from './reducer';
import * as phonesActions from './reducer';

export { phonesActions };

export default phonesReducer;
